import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import { addProduct, updateProduct, getCategories } from '../api/products';

Modal.setAppElement('#root');

const ProductModal = ({ isOpen, onClose, initialData }) => {
  const isEdit = Boolean(initialData);
  const [form, setForm] = useState(
    initialData || {
      name: '',
      category: '',
      category_id: '',
      description: '',
      quantity: '',
      import_price: '',
      selling_price: '',
      status: 'in_store',
    }
  );
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const response = await getCategories();
        if (response.data && response.data.data) {
          setCategories(response.data.data);
        }
      } catch (error) {
        console.error('Failed to load categories:', error);
        toast.error('Failed to load categories');
      } finally {
        setCategoriesLoading(false);
      }
    };

    if (isOpen) {
      loadCategories();
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isEdit) {
        await updateProduct({ ...form, product_id: initialData.id });
        toast.success('Product updated');
      } else {
        await addProduct(form);
        toast.success('Product added');
      }
      onClose(true); // refresh list
    } catch (err) {
      console.error(err);
      toast.error(
        err.response?.data?.message || 'Request failed, please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onClose(false)}
      className="modal"
      overlayClassName="overlay"
    >
      <h2>{isEdit ? 'Edit Product' : 'Add Product'}</h2>
      <form onSubmit={handleSubmit} className="form-grid">
        <label>
          Name
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Category
          <select
            name="category"
            value={form.category || ''}
            onChange={handleChange}
            required
            disabled={categoriesLoading}
          >
            <option value="">Select category</option>
            {categories.map((category) => (
              <option key={category.id} value={category.name}>
                {category.name}
              </option>
            ))}
          </select>
        </label>

        <label className="full">
          Description
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
          />
        </label>

        <label>
          Quantity
          <input
            type="number"
            name="quantity"
            value={form.quantity}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Import Price
          <input
            type="number"
            name="import_price"
            value={form.import_price}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Selling Price
          <input
            type="number"
            name="selling_price"
            value={form.selling_price}
            onChange={handleChange}
            required
          />
        </label>

        <div className="actions full">
          <button type="submit" disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </button>
          <button type="button" onClick={() => onClose(false)} disabled={loading}>
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ProductModal;
